import React, { useState, useEffect, useRef } from "react";
import { DataTable } from 'primereact/datatable';
import axios from 'axios';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Paginator } from 'primereact/paginator';
import { Link } from "react-router-dom";
import { InputText } from 'primereact/inputtext';
import { Dropdown } from "primereact/dropdown";
import LoadingSpinner from "../Spinner/LoadingSpinner";
import { useHistory } from 'react-router-dom';
import * as Designations from '../../enums/Designations';
import * as Travelmodes from '../../enums/Travelmodes';
import { Button } from "primereact/button";
import { MultiSelect } from 'primereact/multiselect';
import exportData from "../../services/exportToExcelService";
import { Toolbar } from "primereact/toolbar";
import * as Genders from '../../enums/Genders';
import AccessControl from "../AccessControl";
import NoAccess from "../NoAccess";
import { RowsPerPageDropdown } from "../../enums/RowsPerPageOptions";
import { Tooltip } from 'primereact/tooltip';
import * as RegistrationStatus from "../../enums/RegistrationStatus";
import { Dialog } from 'primereact/dialog';


const AttendeesDirectlyRegisterd = () => {

    // Hooks
    const [participantlist, setParticipantlist] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [fullName, setfullName] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [boardingcityfilter, setboardingcityfilter] = useState(null);
    const [hospitalNamefilter, sethospitalNamefilter] = useState(null);
    const [companyNameFilter, setcompanyNameFilter] = useState(null);
    const [filterEmail, setFilterEmail] = useState(null);
    const [filterMobileNo, setFilterMobileNo] = useState(null);
    const lazyState = useRef({
        first: 0,
        rows: RowsPerPageDropdown[0],
        page: 1,
        sortField: null,
        sortOrder: 1,
        ParticipantNameFilter: null,
        EmailFilter: null,
        MobileNoFilter: null,
        CityFilter: null,
        StateFilter: null,
        CountryFilter: null,
        BoardingCityFilter: null,
        HospitalNameFilter: null,
        Designationfilter: null,
        Toeventcityfilter: null,
        Fromeventcityfilter: null,
        Genderfilter: null,
        registrationStatus : null
    }); // For Sorting And Pagination Purpose
    const [enableFilter, setEnableFilter] = useState(false);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [isExportExcel, setIsExportExcel] = useState(false);
    const [Cityfilter, setCityfilter] = useState(null);
    const [Statefilter, setStatefilter] = useState(null);
    const [Countryfilter, setCountryfilter] = useState(null);
    const [SerialNumber, setSerialNumber] = useState(null);
    const [filterDialog, setFilterDialog] = useState(false);

    // Const
    const toast = useRef(null);
    const dt = useRef(null);
    const history = useHistory();
    let orderedSelectedColumns = [];
    let unSelectedColumns = [];

    // On Screen Load
    useEffect(() => {
        getparticipantlist();
        document.documentElement.style.setProperty('overflow', 'hidden')
    }, []);


    // Get All Participants
    const getparticipantlist = (isExportExcel = false, event) => {
        setIsLoading(true);
        if (!isExportExcel) setParticipantlist([]);
        axios.post('/api/Participant/GetAll', {
            paginationRequired: !isExportExcel,
            SortDirection: lazyState.current.sortOrder,
            PageSize: lazyState.current.rows,
            CurrentPageNumber: event && event.rows ? ((event.first / event.rows) + 1) : lazyState.current.page,
            SortField: event && event.sortField ? event.sortField : "Firstname",
            registrationStatus: lazyState.current.registrationStatus ? lazyState.current.registrationStatus.name.trim() : null,
            registrationStatusSearchOprator: lazyState.current.registrationStatus ? 'Equals' : 'NotEquals',
            IsDirectRedister: true,
            FullName: lazyState.current.ParticipantNameFilter ? lazyState.current.ParticipantNameFilter.trim() : null,
            Email: lazyState.current.EmailFilter ? lazyState.current.EmailFilter.trim() : null,
            MobileNo: lazyState.current.MobileNoFilter ? lazyState.current.MobileNoFilter.trim() : null,
            Designation: lazyState.current.Designationfilter ? lazyState.current.Designationfilter.name.trim() : null,
            Gender: lazyState.current.Genderfilter ? lazyState.current.Genderfilter.name.trim() : null,
            ToEventCity: lazyState.current.Toeventcityfilter ? lazyState.current.Toeventcityfilter.code.trim() : null,
            FromEventCity: lazyState.current.Fromeventcityfilter ? lazyState.current.Fromeventcityfilter.code.trim() : null,
            City: lazyState.current.CityFilter ? lazyState.current.CityFilter.trim() : null,
            State: lazyState.current.StateFilter ? lazyState.current.StateFilter.trim() : null,
            Country: lazyState.current.CountryFilter ? lazyState.current.CountryFilter.trim() : null,
            BoardingCity: lazyState.current.BoardingCityFilter ? lazyState.current.BoardingCityFilter.trim() : null,
            SerialNumber: lazyState.current.serialnumber ? lazyState.current.serialnumber.trim() : null,
            HospitalName: lazyState.current.HospitalNameFilter ? lazyState.current.HospitalNameFilter.trim() : null
        }).then(Response => {
            if (!isExportExcel) setParticipantlist([]);
            let tempData = [];
            for (let dataObj of Response.data.data) {
                // Pass body data in excelsheets.
                let allExcelData;
                let excelcolumnData = {
                    Id: dataObj.serialNumber,
                    Name: dataObj.fullName,
                    Hospital: dataObj.hospitalName,
                    Email: dataObj.email,
                    MobileNo: dataObj.mobileNo,
                };
                if (selectedColumns.length > 0) {
                    for (let selectedColumn of selectedColumns) {
                        let fieldName = selectedColumn.field;
                        let headerName = selectedColumn.header;
                        excelcolumnData = { ...excelcolumnData, [headerName]: dataObj[fieldName] }
                    };
                    tempData.push(excelcolumnData);
                } else {
                    allExcelData = {
                        Id: dataObj.serialNumber,
                        Name: dataObj.fullName,
                        Hospital: dataObj.hospitalName,
                        Email: dataObj.email,
                        MobileNo: dataObj.mobileNo,
                    };
                    tempData.push(allExcelData);
                };
            };
            if (isExportExcel) {
                exportData(tempData, 'AttendeesDirectlyRegistered');
                setIsLoading(false);
                return false;
            };
            setTotalRecords(Response.data.totalRecords);
            setParticipantlist(Response.data.data);
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Oops! Something Went Wrong!', life: 3000 });
        });
    };

    const SerialNumberFilterTemplate = () => {
        return <InputText id="serialnumber" value={SerialNumber} placeholder="Sr No." onChange={(e) => setSerialNumber(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: "5rem" }} />;
    };

    
    const RegistrationStatusTemplate = () => {
        return (
            <Dropdown
                value={lazyState.current.registrationStatus}
                options={RegistrationStatus.RegistrationStatus}
                optionLabel="name"
                showClear
                onChange={(e) => {
                    lazyState.current.registrationStatus = e.target.value ? e.target.value : null;
                    getparticipantlist(isExportExcel, { registrationStatus: e.value });
                    e.preventDefault();
                }}
                placeholder="Select Status"
                className="p-column-filter"
                style={{ minWidth: "12rem" }}
            />
        );
    };

    const UserFilterTemplate = () => {
        return (
            <InputText id="fullName" value={fullName} placeholder="Enter First Name"
                onChange={(e) => setfullName(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} />
        );
    };

    const BoardingCityFilterTemplate = () => {
        return (
            <InputText id="boardingcityname" value={boardingcityfilter} placeholder="Enter Boarding City"
                onChange={(e) => setboardingcityfilter(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: '12rem' }} />
        );
    };

    const HospitalFilterTemplate = () => {
        return (
            <InputText id="hospitalname" value={hospitalNamefilter} placeholder="Enter Hospital Name"
                onChange={(e) => sethospitalNamefilter(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: '12rem' }} />
        );
    };

    const EmailFilterTemplate = () => {
        return (
            <InputText id="Email" value={filterEmail} placeholder="Enter Email"
                onChange={(e) => setFilterEmail(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: '12rem' }} />
        );
    };

    const MobileFilterTemplate = () => {
        return (
            <InputText id="Mobile" value={filterMobileNo} placeholder="Enter Mobile No."
                onChange={(e) => setFilterMobileNo(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: '12rem' }} />
        );
    };
    const DesignationFilterTemplate = () => {
        return (
            <Dropdown value={lazyState.current.Designationfilter} options={Designations.Designation} optionLabel="name" showClear onChange={(e) => { lazyState.current.Designationfilter = (e.target.value ? e.target.value : null); getparticipantlist(isExportExcel, { Designation: e.value }); e.preventDefault() }} placeholder="Select Designation" className="p-column-filter" style={{ minWidth: '12rem' }} />
        );
    };

    const GenderFilterTemplate = () => {
        return (
            <Dropdown value={lazyState.current.Genderfilter} options={Genders.Gender} optionLabel="name" showClear onChange={(e) => { lazyState.current.Genderfilter = (e.target.value ? e.target.value : null); getparticipantlist(isExportExcel, { Gender: e.value }); e.preventDefault() }} placeholder="Select Gender" className="p-column-filter" style={{ minWidth: '12rem' }} />
        );
    };

    const ToEventCityTemplate = () => {
        return (
            <Dropdown value={lazyState.current.Toeventcityfilter} options={Travelmodes.Travelmode} optionLabel="name" showClear onChange={(e) => { lazyState.current.Toeventcityfilter = (e.target.value ? e.target.value : null); getparticipantlist(isExportExcel, { ToEventCity: e.value }); e.preventDefault() }} placeholder="Select Travel Mode " className="p-column-filter" style={{ minWidth: '12rem' }} />
        );
    };


    const FromEventCityTemplate = () => {
        return (
            <Dropdown value={lazyState.current.Fromeventcityfilter} options={Travelmodes.Travelmode} optionLabel="name" showClear onChange={(e) => { lazyState.current.Fromeventcityfilter = (e.target.value ? e.target.value : null); getparticipantlist(isExportExcel, { FromEventCity: e.value }); e.preventDefault() }} placeholder="Select Travel Mode" className="p-column-filter" style={{ minWidth: '12rem' }} />
        );
    };

    const CityFilterTemplate = () => {
        return (
            <InputText id="city" value={Cityfilter} placeholder="Enter City"
                onChange={(e) => setCityfilter(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: '12rem' }} />
        );
    };

    const StateFilterTemplate = () => {
        return (
            <InputText id="state" value={Statefilter} placeholder="Enter State"
                onChange={(e) => setStatefilter(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: '12rem' }} />
        );
    };

    const CountryFilterTemplate = () => {
        return (
            <InputText id="country" value={Countryfilter} placeholder="Enter Country"
                onChange={(e) => setCountryfilter(e.target.value)} onKeyDown={(e) => UserFilterOnEnter(e)} style={{ minWidth: '12rem' }} />
        );
    };

    const UserFilterOnEnter = (e) => {
        if (e.key == "Enter") {
            setIsLoading(true);
            let data = e.target.id;
            switch (data) {
                case "fullName":
                    lazyState.current.ParticipantNameFilter = e.target.value ? e.target.value : null
                    break;
                case "boardingcityname":
                    lazyState.current.BoardingCityFilter = e.target.value ? e.target.value : null
                    break;
                case "hospitalname":
                    lazyState.current.HospitalNameFilter = e.target.value ? e.target.value : null
                    break;
                case "company":
                    lazyState.current.CompanyFilter = e.target.value ? e.target.value : null
                    break;
                case "Email":
                    lazyState.current.EmailFilter = e.target.value ? e.target.value : null
                    break;
                case "Mobile":
                    lazyState.current.MobileNoFilter = e.target.value ? e.target.value : null
                    break;
                case "city":
                    lazyState.current.CityFilter = e.target.value ? e.target.value : null
                    break;
                case "state":
                    lazyState.current.StateFilter = e.target.value ? e.target.value : null
                    break;
                case "country":
                    lazyState.current.CountryFilter = e.target.value ? e.target.value : null
                    break;
                case "serialnumber":
                    lazyState.current.serialnumber = e.target.value ? e.target.value : null;
                    break;
            };
            getparticipantlist(isExportExcel);
            setIsLoading(false);
        } else {
            setIsLoading(true);
            let data = e.target.id;
            switch (data) {
                case "fullName":
                    lazyState.current.ParticipantNameFilter = null
                    break;
                case "boardingcityname":
                    lazyState.current.BoardingCityFilter = null
                    break;
                case "hospitalname":
                    lazyState.current.HospitalNameFilter = null
                    break;
                case "company":
                    lazyState.current.CompanyFilter = null
                    break;
                case "Email":
                    lazyState.current.EmailFilter = null
                    break;
                case "Mobile":
                    lazyState.current.MobileNoFilter = null
                    break;
                case "city":
                    lazyState.current.CityFilter = null
                    break;
                case "state":
                    lazyState.current.StateFilter = null
                    break;
                case "country":
                    lazyState.current.CountryFilter = null
                    break;
                case "serialnumber":
                    lazyState.current.serialnumber = null;
                    break;
            };
            getparticipantlist(isExportExcel);
            setIsLoading(false);
        };
    };

    // For Sorting 
    const onSort = (event) => {
        lazyState.current.sortField = event.sortField;
        lazyState.current.sortOrder = event.sortOrder;
        lazyState.current.first = event.first;
        lazyState.current.rows = event.rows;
        getparticipantlist(isExportExcel, lazyState.current);
    };

    //pagination
    const onBasicPageChange = (event) => {
        // const newPage = event.first / event.rows + 1;
        // if (newPage !== lazyState.current.first / lazyState.current.rows + 1) {
        setIsLoading(true);
        lazyState.current.sortField = lazyState.current.sortField;
        lazyState.current.sortOrder = lazyState.current.sortOrder;
        lazyState.current.first = event.first;
        lazyState.current.rows = event.rows;
        getparticipantlist(isExportExcel, lazyState.current);
        setIsLoading(false);
        // };
    };

    //Template for pagination
    const template2 = {
        layout: ' CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown',
        'CurrentPageReport': (options) => {
            return (
                <span className="paginator-current-report" style={{ color: 'var(--text-color)', userSelect: 'none' }}>
                    Showing {options.first} to {options.last} of {options.totalRecords} entries
                </span>
            );
        },
        RowsPerPageDropdown: (options) => {
            return (
                <span className="paginator-rows-per-page">
                    Items Per Page :<Dropdown value={options.value} options={RowsPerPageDropdown} onChange={options.onChange} />
                </span>
            );
        },
    };

    const ButtonMailto = (rowData) => {
        return (
            <Link className='linkcolors' id='mailto'
                to='#'
                onClick={(e) => {
                    window.location.href = `mailto:${rowData.email}`;
                    e.preventDefault();
                }}
            >{rowData.email}
            </Link>
        );
    };

    const ButtonPhoneto = (rowData) => {
        return (
            <Link className='linkcolors' id='callto'
                to='#'
                onClick={(e) => {
                    window.location.href = `tel:${rowData.mobileNo}`;
                    e.preventDefault();
                }}
            >{rowData.mobileNo}
            </Link>
        );
    };

    const ViewAttendees = (rowData) => {
        return (
            <AccessControl allowedPermissions={["view:attendeesdirectlyregistered"]}>
                <Link className='linkcolors' id='viewattendee'
                    to='#'
                    onClick={(e) => {
                        history.push('/home/viewparticipant/' + rowData.id)
                    }}
                >{rowData.fullName}
                </Link>
            </AccessControl>
        );
    };

    const exportExcel = () => {
        getparticipantlist(true);
    };

    const removeFilter = () => {
        lazyState.current.CompanyFilter = null;
        setcompanyNameFilter(null);
        lazyState.current.ParticipantNameFilter = null;
        setfullName(null);
        lazyState.current.BoardingCityFilter = null;
        setboardingcityfilter(null);
        lazyState.current.CityFilter = null;
        setCityfilter(null);
        lazyState.current.CountryFilter = null;
        setCountryfilter(null);
        lazyState.current.Designationfilter = null;
        lazyState.current.HospitalNameFilter = null;
        sethospitalNamefilter(null);
        lazyState.current.EmailFilter = null;
        setFilterEmail(null);
        lazyState.current.MobileNoFilter = null;
        setFilterMobileNo(null);
        lazyState.current.Genderfilter = null;
        lazyState.current.StateFilter = null;
        setStatefilter(null);
        lazyState.current.Toeventcityfilter = null;
        lazyState.current.Fromeventcityfilter = null;
        lazyState.current.serialnumber = null;
        setSerialNumber(null);
        lazyState.current.registrationStatus = null;
        getparticipantlist(isExportExcel);
    };

    const SearchFilter = () => {
        lazyState.current.page = 1;
        lazyState.current.first = 0;
        lazyState.current.ParticipantNameFilter = fullName;
        lazyState.current.BoardingCityFilter = boardingcityfilter;
        lazyState.current.HospitalNameFilter = hospitalNamefilter;
        lazyState.current.EmailFilter = filterEmail;
        lazyState.current.MobileNoFilter = filterMobileNo;
        lazyState.current.CityFilter = Cityfilter;
        lazyState.current.StateFilter = Statefilter;
        lazyState.current.CountryFilter = Countryfilter;
        lazyState.current.serialnumber = SerialNumber;
        getparticipantlist();
        setFilterDialog(false);
    };

    const filterDialogFooter = (
        <div className="filter-dialog-footer">
            <Button label="Clear Filter" icon="pi pi-filter-slash" className="p-button-outlined" onClick={() => { removeFilter(); setFilterDialog(false); }} />
            <Button label="Apply Filter" icon="pi pi-check" className="p-button-primary" onClick={() => SearchFilter()} />
        </div>
    );

    // Left Side Toolbar
    const leftToolbarTemplate = () => {
        return (
            <div className="my-2 admin-toolbar-left">
                <h4 className="headerfont m-auto mr-2">Count : {totalRecords}</h4>
            </div>
        );
    };

    // Right Side Toolbar
    const rightToolbarTemplate = () => {
        return (
            <div className="my-2 admin-toolbar-right">
                <Button label="Filter" icon="pi pi-filter" className="p-button-outlined mr-2 mobile-only-btn" onClick={() => setFilterDialog(true)} />
                <AccessControl allowedPermissions={["route:attendeesdirectlyregistered"]}>
                    <Button disabled={lazyState.current.CompanyFilter == null && lazyState.current.ParticipantNameFilter == null && lazyState.current.BoardingCityFilter == null
                        && lazyState.current.CityFilter == null && lazyState.current.CountryFilter == null && lazyState.current.Designationfilter == null &&
                        lazyState.current.HospitalNameFilter == null && lazyState.current.EmailFilter == null && lazyState.current.MobileNoFilter == null &&
                        lazyState.current.Genderfilter == null && lazyState.current.StateFilter == null && lazyState.current.Toeventcityfilter == null &&
                        lazyState.current.serialnumber == null && lazyState.current.Fromeventcityfilter == null && lazyState.current.registrationStatus == null ? true : false}
                        icon="pi pi-filter-slash" className="mr-2" onClick={() => removeFilter()} tooltip="Reset Filter" tooltipOptions={{ position: "bottom", className: "showtooltip" }} outlined></Button>
                </AccessControl>
                <div className="my-2 desktop-only-btn">{header}</div>
                <AccessControl allowedPermissions={["export:attendeesdirectlyregistered"]}>
                    <Button disabled={!(participantlist != null && participantlist.length > 0)} tooltip="Export Excel" tooltipOptions={{ position: "bottom", className: "showtooltip" }} onClick={() => { exportExcel(); }} icon="pi pi-file-excel" className="mr-2" outlined />
                </AccessControl>
            </div>
        )
    };

    //#region Method for Column toggle
    const hidecolumns = [
        { field: "designation", header: "Designation" },
        { field: "gender", header: "Gender" },
        { field: "boardingcityname", header: "BoardingCity" },
        { field: "cityname", header: "City" },
        { field: "statename", header: "State" },
        { field: "countryname", header: "Country" },
        { field: "travelmode_Inbound", header: "Travel In Bound" },
        { field: "travelmode_Outbound", header: "Travel Out Bound" }
    ];

    const onColumnToggle = (event) => {
        let selectedColumns = event.value;
        orderedSelectedColumns = hidecolumns.filter(col => selectedColumns.some(sCol => sCol.field === col.field));
        unSelectedColumns = hidecolumns.filter(o => !selectedColumns.some(i => i.field === o.field && i.header === o.header));
        unselectedColumnData();
        setSelectedColumns(orderedSelectedColumns);
    };

    const unselectedColumnData = () => {
        let isFiltered = false;
        if (unSelectedColumns) {
            unSelectedColumns.map(col => {
                switch (col.header) {
                    case "Designation":
                        if (lazyState.current.Designationfilter != null) {
                            lazyState.current.Designationfilter = null;
                            isFiltered = true;
                            return lazyState.current.Designationfilter;
                        };
                        break;
                    case "Gender":
                        if (lazyState.current.Genderfilter != null) {
                            lazyState.current.Genderfilter = null;
                            isFiltered = true;
                            return lazyState.current.Genderfilter;
                        };
                        break;
                    case "BoardingCity":
                        if (lazyState.current.BoardingCityFilter != null) {
                            lazyState.current.BoardingCityFilter = null;
                            isFiltered = true;
                            return setboardingcityfilter(null);
                        };
                        break;
                    case "City":
                        if (lazyState.current.CityFilter != null) {
                            lazyState.current.CityFilter = null;
                            isFiltered = true;
                            return setCityfilter(null);
                        };
                        break;
                    case "State":
                        if (lazyState.current.StateFilter != null) {
                            lazyState.current.StateFilter = null;
                            isFiltered = true;
                            return setStatefilter(null);
                        };
                        break;
                    case "Country":
                        if (lazyState.current.CountryFilter != null) {
                            lazyState.current.CountryFilter = null;
                            isFiltered = true;
                            return setCountryfilter(null);
                        };
                        break;
                    case "Travel In Bound":
                        if (lazyState.current.Toeventcityfilter != null) {
                            lazyState.current.Toeventcityfilter = null;
                            isFiltered = true;
                            return lazyState.current.Toeventcityfilter;
                        };
                        break;
                    case "Travel Out Bound":
                        if (lazyState.current.Fromeventcityfilter != null) {
                            lazyState.current.Fromeventcityfilter = null;
                            isFiltered = true;
                            return lazyState.current.Fromeventcityfilter;
                        };
                        break;
                };
            });
            if (isFiltered) {
                getparticipantlist();
            };
        };
    };

    const header = (
        <AccessControl allowedPermissions={["route:attendeesdirectlyregistered"]}>
            <div style={{ textAlign: 'left', marginRight: '10px' }}>
                <MultiSelect className="more-columns-multiselect" value={selectedColumns} options={hidecolumns} optionLabel="header" placeholder="More Columns" onChange={onColumnToggle} display="chip" />
            </div>
        </AccessControl>
    );

    const hideColumnsFilterTemplate = (column) => {
        switch (column) {
            case "Designation":
                return DesignationFilterTemplate;
            case "Gender":
                return GenderFilterTemplate;
            case "BoardingCity":
                return BoardingCityFilterTemplate;
            case "City":
                return CityFilterTemplate;
            case "State":
                return StateFilterTemplate;
            case "Travel In Bound":
                return ToEventCityTemplate;
            case "Travel Out Bound":
                return FromEventCityTemplate;
            case "Country":
                return CountryFilterTemplate;
            case "Gender":
                return GenderFilterTemplate;
        };
    };

    const sortColumn = {
        "Designation": 'Designation',
        "boardingcityname": 'boardingcityname',
        "cityname": 'cityname',
        "Statename": 'Statename',
        "Countryname": 'Countryname',
        "Travel In Bound": 'Travelmode_Inbound',
        "Travel Out Bound": 'Travelmode_Outbound',
        "Gender": 'Gender',
    };

    const hidecolumnComponents = selectedColumns.map(col => {
        return <Column key={col.field} field={col.field} header={col.header} sortable headerStyle={{ width: '15%', minWidth: '15rem' }} sortField={sortColumn[col.header]}
            filter showFilterMenu={false} filterElement={hideColumnsFilterTemplate(col.header)} />;
    });
    //#endregion

    return (
        <AccessControl allowedPermissions={["route:attendeesdirectlyregistered"]} renderNoAccess={() => <NoAccess />}>
            <div className="trico-Grid">
                <Toast ref={toast} />
                {isLoading ? <LoadingSpinner /> :
                    (
                        <>
                            <div className="p-col">
                                <div className="card">
                                    <h5 className="headerfont"><span><i className="fa fa-solid fa-users mr-2"></i>Attendees Directly Registered</span></h5>
                                    <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate} className="mb-3"></Toolbar>
                                    <Tooltip target="#viewattendee" content="View Attendee" />
                                    <Tooltip target="#mailto" content="Mail To" />
                                    <Tooltip target="#callto" content="Call To" />
                                    <div className="attendee-status-desktop-table">
                                        <DataTable size="small" lazy rows={lazyState.current.rows} scrollable scrollHeight="calc(100vh - 250px)"
                                            onSort={onSort} sortField={lazyState.current.sortField} sortOrder={lazyState.current.sortOrder}
                                            removableSort stripedRows ref={dt} value={participantlist} selection={participantlist} onSelectionChange={(e) => setParticipantlist(e.value)}
                                            dataKey="Id" className="datatable-responsive" responsiveLayout="scroll" filterDisplay="row" >
                                            <Column alignFrozen="left" field="serialNumber" header="Id" sortField="SerialNumber" sortable frozen headerStyle={{ width: "3%", minWidth: "5rem" }} filter showFilterMenu={false} filterElement={SerialNumberFilterTemplate} showClearButton></Column>
                                            <Column body={ViewAttendees} sortField="FullName" frozen field="fullName" header="Name" sortable headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} filterElement={UserFilterTemplate} showClearButton></Column>
                                            <Column field="hospitalName" sortField="HospitalName" header="Hospital" sortable headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} filterElement={HospitalFilterTemplate} showClearButton></Column>
                                            <Column body={ButtonMailto} sortField="Email" field="email" header="Email" sortable headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} filterElement={EmailFilterTemplate}></Column>
                                            <Column body={ButtonPhoneto} sortField="MobileNo" field="mobileNo" header="Mobile No." sortable headerStyle={{ width: '15%', minWidth: '15rem' }} filter showFilterMenu={false} filterElement={MobileFilterTemplate}></Column>
                                            <Column
                                                field="registrationStatus"
                                                sortField="RegistrationStatus"
                                                header="Registrationstatus"
                                                sortable
                                                headerStyle={{ width: "10%", minWidth: "15rem" }}
                                                style={{ overflowWrap: "anywhere" }}
                                                filter
                                                showFilterMenu={false}
                                                filterElement={RegistrationStatusTemplate}
                                            ></Column>
                                            {hidecolumnComponents}
                                        </DataTable>
                                    </div>
                                    <div className="attendee-status-mobile-cards">
                                        {participantlist && participantlist.length > 0 ? (
                                            <div className="attendee-card-grid">
                                                {participantlist.map((row, idx) => (
                                                    <div className="attendee-mobile-card" key={row.id || idx}>
                                                        <div className="attendee-card-top">
                                                            <span className="attendee-card-id">#{row.serialNumber || (idx + 1)}</span>
                                                            <div className="attendee-card-badges">
                                                                {row.registrationStatus && <span className="status-pill">{row.registrationStatus}</span>}
                                                                {row.designation && <span className="designation-pill">{row.designation}</span>}
                                                                {row.gender && <span className="batch-tag">{row.gender}</span>}
                                                            </div>
                                                        </div>
                                                        <div className="attendee-card-name">
                                                            {ViewAttendees(row)}
                                                        </div>
                                                        <div className="attendee-card-details">
                                                            {row.hospitalName && (
                                                                <div className="attendee-detail-item">
                                                                    <span className="detail-label"><i className="pi pi-building mr-1"></i>Hospital:</span>
                                                                    <span className="detail-value">{row.hospitalName}</span>
                                                                </div>
                                                            )}
                                                            {row.email && (
                                                                <div className="attendee-detail-item">
                                                                    <span className="detail-label"><i className="pi pi-envelope mr-1"></i>Email:</span>
                                                                    <span className="detail-value">{ButtonMailto(row)}</span>
                                                                </div>
                                                            )}
                                                            {row.mobileNo && (
                                                                <div className="attendee-detail-item">
                                                                    <span className="detail-label"><i className="pi pi-phone mr-1"></i>Mobile:</span>
                                                                    <span className="detail-value">{ButtonPhoneto(row)}</span>
                                                                </div>
                                                            )}
                                                            {row.boardingcityname && (
                                                                <div className="attendee-detail-item">
                                                                    <span className="detail-label"><i className="pi pi-map-marker mr-1"></i>Boarding City:</span>
                                                                    <span className="detail-value">{row.boardingcityname}</span>
                                                                </div>
                                                            )}
                                                            {(row.cityname || row.statename || row.countryname) && (
                                                                <div className="attendee-detail-item">
                                                                    <span className="detail-label"><i className="pi pi-globe mr-1"></i>Location:</span>
                                                                    <span className="detail-value">{[row.cityname, row.statename, row.countryname].filter(Boolean).join(', ')}</span>
                                                                </div>
                                                            )}
                                                            {row.travelmode_Inbound && (
                                                                <div className="attendee-detail-item">
                                                                    <span className="detail-label"><i className="pi pi-arrow-right mr-1"></i>Inbound Travel:</span>
                                                                    <span className="detail-value">{row.travelmode_Inbound}</span>
                                                                </div>
                                                            )}
                                                            {row.travelmode_Outbound && (
                                                                <div className="attendee-detail-item">
                                                                    <span className="detail-label"><i className="pi pi-arrow-left mr-1"></i>Outbound Travel:</span>
                                                                    <span className="detail-value">{row.travelmode_Outbound}</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="p-text-center p-p-4" style={{ textAlign: 'center', padding: '2rem', color: '#888' }}>
                                                No records found
                                            </div>
                                        )}
                                    </div>
                                    <Paginator className='justify-content-end admin-paginator' first={lazyState.current.first} rows={lazyState.current.rows} totalRecords={totalRecords} template={template2} rowsPerPageOptions={RowsPerPageDropdown} onPageChange={onBasicPageChange} ></Paginator>
                                </div>
                            </div >
                            <Dialog visible={filterDialog} style={{ width: '90vw', maxWidth: '600px' }} header="Filter Attendees" modal className="p-fluid admin-dialog attendee-filter-dialog" footer={filterDialogFooter} onHide={() => setFilterDialog(false)}>
                                <div className="filter-dialog-grid">
                                    <div className="filter-field-item">
                                        <label htmlFor="m_serialNumber">Sr No.</label>
                                        <InputText id="m_serialNumber" value={SerialNumber || ''} placeholder="Sr No." onChange={(e) => setSerialNumber(e.target.value)} />
                                    </div>
                                    <div className="filter-field-item">
                                        <label htmlFor="m_fullName">Name</label>
                                        <InputText id="m_fullName" value={fullName || ''} placeholder="Enter Name" onChange={(e) => setfullName(e.target.value)} />
                                    </div>
                                    <div className="filter-field-item">
                                        <label htmlFor="m_hospitalname">Hospital</label>
                                        <InputText id="m_hospitalname" value={hospitalNamefilter || ''} placeholder="Enter Hospital Name" onChange={(e) => sethospitalNamefilter(e.target.value)} />
                                    </div>
                                    <div className="filter-field-item">
                                        <label htmlFor="m_email">Email</label>
                                        <InputText id="m_email" value={filterEmail || ''} placeholder="Enter Email" onChange={(e) => setFilterEmail(e.target.value)} />
                                    </div>
                                    <div className="filter-field-item">
                                        <label htmlFor="m_mobile">Mobile No.</label>
                                        <InputText id="m_mobile" value={filterMobileNo || ''} placeholder="Enter Mobile No." onChange={(e) => setFilterMobileNo(e.target.value)} />
                                    </div>
                                    <div className="filter-field-item">
                                        <label htmlFor="m_status">Registration Status</label>
                                        <Dropdown id="m_status" value={lazyState.current.registrationStatus} options={RegistrationStatus.RegistrationStatus} optionLabel="name" showClear onChange={(e) => { lazyState.current.registrationStatus = e.value || null; }} placeholder="Select Status" />
                                    </div>
                                    <div className="filter-field-item">
                                        <label htmlFor="m_designation">Designation</label>
                                        <Dropdown id="m_designation" value={lazyState.current.Designationfilter} options={Designations.Designation} optionLabel="name" showClear onChange={(e) => { lazyState.current.Designationfilter = e.value || null; }} placeholder="Select Designation" />
                                    </div>
                                    <div className="filter-field-item">
                                        <label htmlFor="m_gender">Gender</label>
                                        <Dropdown id="m_gender" value={lazyState.current.Genderfilter} options={Genders.Gender} optionLabel="name" showClear onChange={(e) => { lazyState.current.Genderfilter = e.value || null; }} placeholder="Select Gender" />
                                    </div>
                                    <div className="filter-field-item">
                                        <label htmlFor="m_boardingcity">Boarding City</label>
                                        <InputText id="m_boardingcity" value={boardingcityfilter || ''} placeholder="Enter Boarding City" onChange={(e) => setboardingcityfilter(e.target.value)} />
                                    </div>
                                    <div className="filter-field-item">
                                        <label htmlFor="m_city">City</label>
                                        <InputText id="m_city" value={Cityfilter || ''} placeholder="Enter City" onChange={(e) => setCityfilter(e.target.value)} />
                                    </div>
                                    <div className="filter-field-item">
                                        <label htmlFor="m_state">State</label>
                                        <InputText id="m_state" value={Statefilter || ''} placeholder="Enter State" onChange={(e) => setStatefilter(e.target.value)} />
                                    </div>
                                    <div className="filter-field-item">
                                        <label htmlFor="m_country">Country</label>
                                        <InputText id="m_country" value={Countryfilter || ''} placeholder="Enter Country" onChange={(e) => setCountryfilter(e.target.value)} />
                                    </div>
                                    <div className="filter-field-item">
                                        <label htmlFor="m_toevent">Travel In Bound</label>
                                        <Dropdown id="m_toevent" value={lazyState.current.Toeventcityfilter} options={Travelmodes.Travelmode} optionLabel="name" showClear onChange={(e) => { lazyState.current.Toeventcityfilter = e.value || null; }} placeholder="Select Travel Mode" />
                                    </div>
                                    <div className="filter-field-item">
                                        <label htmlFor="m_fromevent">Travel Out Bound</label>
                                        <Dropdown id="m_fromevent" value={lazyState.current.Fromeventcityfilter} options={Travelmodes.Travelmode} optionLabel="name" showClear onChange={(e) => { lazyState.current.Fromeventcityfilter = e.value || null; }} placeholder="Select Travel Mode" />
                                    </div>
                                </div>
                            </Dialog>
                        </>
                    )
                }
            </div>
        </AccessControl>
    )
};

export default AttendeesDirectlyRegisterd;